export default "__VITE_ASSET__BqOjByCM__"